<!--
    描述：资源组合设置页面
    时间：2020-07-10
    Created by ws
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header">
			<searchArea ref="searchContent"
						v-model="searchForm.sname"
						placeholderName="组合名称"
						:showMore="false"
						@on-search="onSearch"
						@on-refresh="onRefresh">
			</searchArea>
			<div class="btnGroups ml10">
				<el-button type="primary"
						   size="small"
						   @click="addGroup">添加材料组合</el-button>
			</div>
		</div>
		<div class="w-page-container">
			<div class="w-table-layout">
				<div class="w-table-content"
					 v-loading="loading"
					 ref="tableContent">
					<el-table :data="tableData"
							  ref="groupTable"
							  :height="tableH"
							  border
							  highlight-current-row>
						<el-table-column type="index"
										 label="序号"
										 width="70"></el-table-column>
						<el-table-column label="组合名称"
										 min-width="180"
										 prop="sname"
										 align="center"></el-table-column>
						<el-table-column label="包含材料信息"
										 align="center"
										 show-overflow-tooltip>
							<el-table-column label="材料编码"
											 min-width="150"
											 align="center"
											 class-name="combine-cell"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<div v-for="(item, index) in scope.row.resources"
										 :key="'编码' + scope.row.id + index"
										 class="combine-row">
										{{ item.code }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="材料名称"
											 min-width="150"
											 align="center"
											 class-name="combine-cell"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<div v-for="(item, index) in scope.row.resources"
										 :key="'材料名称' + scope.row.id + index"
										 class="combine-row">
										{{ item.sname }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="规格型号"
											 min-width="120"
											 align="center"
											 class-name="combine-cell"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<div v-for="(item, index) in scope.row.resources"
										 :key="'规格型号' + scope.row.id + index"
										 class="combine-row">
										{{ item.specification }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="单位"
											 width="120"
											 align="center"
											 class-name="combine-cell"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<div v-for="(item, index) in scope.row.resources"
										 :key="'单位' + scope.row.id + index"
										 class="combine-row">
										{{ item.unit }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="权重"
											 width="120"
											 align="center"
											 class-name="combine-cell"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<div v-for="(item, index) in scope.row.resources"
										 :key="'权重' + scope.row.id + index"
										 class="combine-row">
										{{ item.weight }}
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="操作"
										 align="center"
										 width="120">
							<template slot-scope="scope">
								<el-button size="mini"
										   icon="el-icon-edit"
										   title="编辑"
										   type="text"
										   @click="doClick(scope.row,'edit')"></el-button>
								<el-button size="mini"
										   icon="el-icon-delete"
										   title="删除"
										   type="text"
										   @click="doClick(scope.row,'delete')"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<!-- 添加材料组合 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 内容区域 -->
			<div class="h100 overflow-hidden">
				<!-- 新增材料 -->
				<add-materials ref="materialsAdd"
							   v-if="dialogObj.type !== ''"
							   :combinationId="curRowId"
							   :groupName="curRowName"
							   @on-error="resetBtnloading"
							   @on-success="onRefresh"></add-materials>
			</div>

			<!-- 底部按钮 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消
				</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	getResourceCombinations,
	deleteResourceCombination
} from '@/api/modules/resource'
import addMaterials from './add_group'
import { mapState } from 'vuex'
export default {
	components: {
		addMaterials
	},
	data() {
		return {
			searchForm: {
				sname: ''
			},
			loading: false,
			btnLoading: false,
			tableData: [],
			tableH: 0,
			curRowId: '', // 当前行的Id
			curRowName: '', // 当前行的 组合名称
			// 弹窗对象
			dialogObj: {
				title:
					'添加材料组合 ( 注意： 所选材料需单位相同， 材料编码前两位相同 )',
				visible: false,
				width: '80%',
				type: ''
			}
		}
	},
	created() {
		this.onSearch()
	},
	mounted() {
		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 查询搜索函数
		onSearch() {
			this.loading = true
			getResourceCombinations({
				type: 1
			})
				.then(res => {
					this.loading = false
					this.tableData = res.data
				})
				.catch(err => {
					this.loading = false
				})
		},

		// 刷新重置页面
		onRefresh() {
			this.btnLoading = false
			this.handleClose()
			this.onSearch()
		},

		// 点击添加材料组合
		addGroup() {
			this.dialogObj.visible = true
			this.dialogObj.type = 'add'
		},

		// 确定 添加
		doConfirm() {
			this.btnLoading = true
			this.$refs.materialsAdd.doSubmit()
		},

		// 弹窗关闭事件
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.type = ''

			// 重置当前激活的  id， name
			this.curRowId = ''
			this.curRowName = ''
		},

		// 操作栏点击
		doClick(row, type) {
			this.curRowId = row.id
			this.curRowName = row.sname

			if (type === 'edit') {
				this.dialogObj.visible = true
				this.dialogObj.type = 'edit'
			} else {
				this.$confirm('确认删除该材料组合吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						deleteResourceCombination({
							id: this.curRowId
						})
							.then(res => {
								this.$message.success('删除成功!')
								// 重载页面
								this.onSearch()
							})
							.catch(err => {
								this.$message.error('删除失败!')
							})
					})
					.catch(() => {})
			}
		},

		// 重置按钮等待状态
		resetBtnloading() {
			setTimeout(() => {
				this.btnLoading = false
			}, 1000)
		}
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		})
	},
	watch: {
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
}
</script>

<style scoped lang="less">
/deep/ .combine-cell {
	padding: 0 !important;

	.cell {
		padding: 0 !important;
	}
}
.combine-row {
	height: 40px;
	line-height: 40px;
	border-bottom: 1px solid #c7c7c7;
	width: 100%;

	&:last-child {
		border-bottom: none;
	}
}
</style>
